import { AddressModal } from "./FormParser/AddressModal";
import { useLocationContext } from "../../context/LocationContext";

const AddressModalContainer = () => {
  const { addressModalOpen, setAddressModalOpen, location, setLocation } =
    useLocationContext();
  return (
    <AddressModal
      isOpen={addressModalOpen}
      onClose={() => setAddressModalOpen(false)}
      formData={location}
      setFormData={setLocation}
      address_id={location.address_id}
    />
  );
};

export default AddressModalContainer;
